import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=b1ab669e&scoped=true&"
import script from "./BankAccounts.vue?vue&type=script&lang=js&"
export * from "./BankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BankAccounts.vue?vue&type=style&index=0&id=b1ab669e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ab669e",
  null
  
)

export default component.exports